import {
    Currency, Modal,
    ICurrency, IModal, IPlatformInfo, ITravel, PlatformInfo, Travel, IDate, IOrder, Order, ITravelData
} from '@/entities'
import {
    ICurrencyGetters,
    IState
} from '../index'
import {
    IGetters
} from './index'
import i18n from "@/i18n";
import { store } from '@/main';
import { ITravelAdditions } from '@/entities/travel/additions/travelAdditions';

function wrapWithPrice(wrapper: string, value: string | number): string {
    return wrapper + value;
}

const currencyGetters: ICurrencyGetters = {
    getAllCurrencies(state: IState): ICurrency[] {
        return state.currencies.map(data => new Currency(data))
    },
    getCurrentCurrency(state: IState): ICurrency {
        return new Currency(state.currency)
    },
    getPriceLabel: (state: IState) => (value: number | string): string => {
        let amount = (typeof value === 'string') ? parseFloat(value) : value;
        let currency: ICurrency = new Currency(state.currency);
        return wrapWithPrice(currency.slug, amount * currency.coefficient);
    },
    wrapPriceLabel: (state: IState) => (value: string): string => {
        let currency: ICurrency = new Currency(state.currency);
        return wrapWithPrice(currency.slug, value);
    }
}

export const styleGetters: any = {
    getCheckboxLabelColor: (state: IState): any => {
        return state.checkboxLabelCol;
    }
}

export const groupTravelGetters: any = {
    getGroupTravel: (state: IState): ITravel | undefined => {
        return state.groupTravel;
    },

    getGroupTravelAdditions: (state: IState): ITravelAdditions | undefined => {
        return state.groupTravel?.travel_additions;
    },
}

export const  emailModalCondition: any = {
    getEmailModalCondition : (state: IState): boolean | undefined => {
        return state.isShowEmailFormActive;
    }
}

export const travelFormatRequestGetters: any = {
    getTravelFormatRequest: (state: IState): string | undefined => {
        return state.travelFormatRequest;
    },
}

export const getters: IGetters = {

    ...currencyGetters,
    ...styleGetters,
    ...groupTravelGetters,
    ...emailModalCondition,
    ...travelFormatRequestGetters,

    getPlatformInfo(state: IState): IPlatformInfo {
        return new PlatformInfo(state.platform);
    },
    getTravel(state: IState): ITravel | undefined {
        let travel = state.travel;
        return travel ? new Travel(travel) : undefined;
    },
    // getModal(state: IState): IModal | undefined {
    //     let modal = state.modal;
    //     return modal ? new Modal(modal) : undefined;
    // },
    getOrder(state: IState): IOrder | undefined {
        let order = state.order;
        return order ? new Order(order) : undefined;
    },

    getLocaleDate: () => (value: IDate, noTime?: boolean): string => {
        let date: Date = (typeof value === 'string') ? new Date(value) : value;
        let res = '';
        if (date) {
            let processor: Function = noTime ? Date.prototype.toLocaleDateString : Date.prototype.toLocaleString;
            processor = processor.bind(date);
            try {
                res = processor(i18n.locale, {
                    // @ts-ignore
                    dateStyle: 'short',
                    timeStyle: 'short'
                });
            } catch (e) {
                res = processor(i18n.locale);
            }
        }
        return res;
    }

}
